import React, {useContext} from 'react';
import { SET_ALERT } from 'context/actions/auth';
import LoadingDialog from 'components/LoadingDialog';
import CustomSnackBar from 'components/CustomSnackBar';

// component
import Header from 'components/Header';
import Footer from 'components/Footer';
import useWindowSize from 'utils/useWindowSize';
import { GlobalContext } from 'context';

export default function HomeLayout({ children }) {


    const { state, dispatch } = useContext(GlobalContext);
    const { sizes } = useWindowSize();
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                    minHeight: '100vh',
                }}
            >
                <main>
                    <Header />
                    <div style={{ flexGrow: 1, marginTop: 140 }}>{children}</div>
                    <Footer />
                </main>
                {/* {!sizes?.sm ? (
                    <div
                        style={{
                            position: 'fixed',
                            top: '27%',
                            left: 30,
                            zIndex: 100,
                            height: 370,
                            width: 70,
                            borderRadius: 5,
                            backgroundColor: '#fff',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            boxShadow: 'rgba(31, 45, 61, 0.125) 0px 0px 30px',
                        }}
                    >
                        <div
                            style={{
                                height: 370,
                                width: 50,
                                backgroundImage: 'url(/icon/mm.jpg)',
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                            }}
                        ></div>
                    </div>
                ) : null} */}
            </div>

            {state.auth.showLoading && <LoadingDialog open={state.auth.showLoading} />}

            {state.auth.alert.isShow && (
                // <Alert severity={system.alert.type} variant="outlined" className="">
                //     asf
                // </Alert>

                <CustomSnackBar
                    open={state.auth.alert.isShow}
                    msg={state.auth.alert.message}
                    handleClose={() => {
                        dispatch({
                            type: SET_ALERT,
                            data: {
                                isShow: false,
                                type: '',
                                message: '',
                            },
                        });
                    }}
                    type={state.auth.alert.type}
                />
            )}
        </>
    );
}
